import useFormApi from "@data-driven-forms/react-form-renderer/use-form-api";
import React, { useEffect, useState } from "react";
import { Grid } from "@mui/system";
import { Button } from "@mui/material";
import { ElementType } from "react";

interface ProductVariantFormTemplateProps {
  formFields: ElementType[],
  onSubmit: (data: any) => void;
  onChange?: (productId: string) => void;
}

export const ProductVariantFormTemplate = ({ formFields, onSubmit, onChange }: ProductVariantFormTemplateProps) => {
  const { getState } = useFormApi();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const { values } = getState();

  useEffect(() => {
    if (!values.productId) return;
    if (onChange) {
      onChange(values.productId);
    }
  }, [values.productId]);

  useEffect(() => {
    if (!isSubmitting) return;
    const { values: updatedValues } = getState();
    onSubmit(updatedValues);
  }, [isSubmitting]);

  return (
    <form
      style={{
        width: '600px'
      }}
      onSubmit={(event) => {
        event.preventDefault();
        setIsSubmitting(true);
      }}
    >
      <Grid container justifyContent="space-between" spacing={1}>
        {formFields}
      </Grid>

      <Button sx={{
        marginTop: '20px'
      }} variant={'contained'} onClick={e => setIsSubmitting(!isSubmitting)}>Submit</Button>

    </form>
  );
};
